import styled, { css } from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const ModalContent = styled.div`
  max-width: 380px;
  margin: 0 auto;
`

export const Counter = styled.span`
  position: relative;
  display: inline-block;
  min-width: 26px;
  height: 26px;
  border-radius: 13px;
  background: #89919c;
  margin: -3px 10px 0 0;

  :after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: white;
    line-height: 28px;
    counter-increment: list;
    content: counter(list);
    transition: all 0.3s ease;
    z-index: 2;
  }
`
export const StepProgress = styled.ul`
  display: flex;
  counter-reset: list;
  margin-bottom: 1rem;
  flex-direction: column;

  ${media.sm`
    flex-direction: row;
    margin-bottom: 3rem;
  `}
`
export const Step = styled.li<{ active: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  list-style-type: none;
  font-size: 18px;
  font-weight: 500;
  color: #89919c;
  margin-right: 1rem;
  margin-bottom: 1rem;

  ${media.sm`
    margin-bottom: 0;    

    :not(:first-child):before {
      content: '';
      display: inline-block;
      background: #89919c;
      height: 2px;
      width: 2.5rem;
      margin-right: 1rem;
    }
  `}

  ${p =>
    p.active &&
    css`
      color: #152735;

      ${Counter} {
        background: #152735;
      }
    `}
`

export const WrapBlock = styled.div``

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
`

export const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`

export const BottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
